var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconOffroad = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.834 9.64C8.107 7.387 10.454 6 13 6c2.545 0 4.893 1.387 6.166 3.64l4.649 8.26c.527.932-.133 2.1-1.187 2.1H3.372c-1.054 0-1.714-1.164-1.187-2.1l4.65-8.26z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconOffroad, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-offroad.04ef0fef.svg";
export { ForwardRef as ReactComponent };